import React from 'react';
import {Card, Grid, Label} from 'semantic-ui-react';
import {isUndefined} from 'lodash'
import {Link} from "react-router-dom";
import {APP} from '../../constants';
import styled from 'styled-components';
import {FiCamera, FiStar} from "react-icons/fi";

const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  line-height: 40px;
  padding: 0 4px;
  background-color: rgba(0, 0, 0, .7);
  color: #FFF;
  margin-top: -40px;
  bottom: 0;
`;

export const PlaceCard = ({from, category, place}) => {

    const {id, name, price_start, price_end, slug, banner, categories} = place;

    let meta = !isUndefined(categories) && categories[0]['name'];

    let image = APP.images.places.small;
    if (banner) {

        image = APP.images.places.path + banner.replace('big', 'small');
    } else if (!isUndefined(categories)) {

        let category_banner = null;

        if (category) {

            let i = 0;
            for (let ix in categories) {

                if (categories[ix]['id'] === category.id) {

                    i = ix;
                }
            }

            meta = categories[i]['name'];

            if (categories[i]['image']) {

                category_banner = categories[i]['image'];
            } else if (categories[i]['parent']['image']) {

                category_banner = categories[i]['parent']['image'];
            } else if (!isUndefined(category) && category.image) {

                category_banner = category.image;
            }
        }

        if (category_banner) {

            image = APP.images.categories.path + category_banner.replace('big', 'small');
        }
    }

    let url = '/';
    url += from === 'search' ? 'places' : from;
    url += `/details/${id}/${slug}`;

    if (category && category.id) {

        url += `?category=${category.id}`;
    }else if(!isUndefined(categories)){

        url += `?category=${categories[0]['id']}`
    }

    return (
        <Grid.Column tablet={16} computer={8}>

            <Card style={{marginBottom: 16}}>
                <div
                    className={'place-card'}
                    style={{
                        backgroundImage: `url(${image})`,
                    }}
                >
                    {/*<Label icon={'heart'} corner={'right'}/>*/}
                    {/*<Label color={'green'} icon={'star'} corner={'left'}/>*/}
                    <Wrapper>
                        <div style={{float: 'left'}}>
                            <FiCamera/> <FiStar/>
                        </div>
                        <div style={{float: 'right'}}>
                            {
                                (price_start && price_end > 0) && `R$${price_start} - R$${price_end}`
                            }
                        </div>
                    </Wrapper>
                </div>
                <Card.Content>
                    <Link
                        to={url}
                    >
                        <Card.Header>{name}</Card.Header>
                    </Link>
                    {
                        (from === 'places' || from === 'search') && <Card.Meta>
                            <span className='date'>{meta}</span>
                        </Card.Meta>
                    }
                </Card.Content>
            </Card>

        </Grid.Column>
    );
};